module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img.fff1941d.webp";